import {ItemGroup} from "./itemGroup";
import {GroupRepository} from "./groupRepository";
import {XmlTagInfo} from "../xmlTagProvider";
import {Form} from "../form/form";
import {CheckboxItem} from "../items/checkbox";
import {ValidateResult} from "../contentType";

export class CheckboxGroup extends ItemGroup<CheckboxItem> {

	constructor(config: XmlTagInfo, form: Form) {
		super(config, form);
	}

	validate() : ValidateResult {
		const valid: boolean = this.cellItems.reduce((result, ci) => result || ci.getVariable(), false);
		return new ValidateResult(valid, []);
	}

}

// @ts-ignore
GroupRepository.register('checkboxGroup', CheckboxGroup);
